<template>
      <Modal v-model="addWhitelistVisible" :title="$t('alarms.complianceChecks.AddWhitelist')" :loading="loading" :mask-closable="false" :styles="{top:'65px'}" width="1000px" :closable="false">
        <div class="complianceChecksWhitelistSearch">
        <Row>
          <!-- 选择公司 -->
          <div v-if="company==1">
            <Col span="4" style="padding-right:10px">
              <Select v-model="companyId" filterable :placeholder="$t('alarms.common.pleaseSelectCompany')" @on-change="getAccountList" :transfer="true" >
                <Option :value="item.id" v-for="item in companyList" :key="item.id">{{item.name}}</Option>
              </Select>
            </Col>
          </div>
          <!-- 选择账户 -->
          <Col span="4" style="padding-right:10px">
            <Select v-model="accountId" filterable :placeholder="$t('alarms.complianceChecks.PleaseSelectAccount')"  @on-change="getRegionList" :transfer="true">
              <Option :value="item.id" v-for="item in accountList" :key="item.name">{{item.name}}</Option>
            </Select>
          </Col>
          <!-- 选择存储区域 -->
          <Col span="4" style="padding-right:10px">
            <Select v-model="region" filterable :placeholder="$t('alarms.complianceChecks.PleaseSelectRegion')" @on-change="getConfigRuleList" :transfer="true">
              <Option :value="item.name" v-for="item in regionList" :key="item.id">{{item.name}}</Option>
            </Select>
          </Col>
          <!-- 选择合规检查 -->
          <Col span="4" style="padding-right:10px">
            <Select v-model="configRule" filterable :placeholder="$t('alarms.complianceChecks.FilterbyComplianceRules')" @on-change="getResourceList" :transfer="true">
              <Option :value="item.configRuleName" v-for="(item,index) in configRuleNamesList" :key="index">{{item.configRuleName}}</Option>
            </Select>
          </Col>
        </Row>
        </div>
        <Table :no-data-text="$t('common.noData')" ref="selection" :columns="column" :loading="modal_loadings" :data="complianceChecksWhitelistData" :height="400" @on-selection-change="getSelection"></Table>
        <div slot="footer">
          <Button size="large" @click="cancel">{{ $t('alarms.common.cancel') }}</Button>
          <Button type="primary" size="large" @click="addWhitelist" :loading="addloading" :disabled="isDisable">
            {{this.$t('alarms.common.addWhitelist')}}
          </Button>
        </div>
      </Modal>
</template>
<script>
    import {setCookie, getCookie} from '../../../../utils/cookieUtil.js';
    import TableComplianceChecksWhitelist from "./TableComplianceChecksWhitelist";

    let addComplianceChecksWhitelist = {};
    let tableComplianceChecksWhitelist  = TableComplianceChecksWhitelist;
    export default {
        name:"addComplianceChecksWhitelist",
        components: {
          TableComplianceChecksWhitelist
        },
        data() {
            return {
                company: getCookie(global.companyId),
                companyId:'',
                accountType:'',
                accountId:'',
                region:'',
                companyList:[],
                regionList:[],
                configRuleNames:[],
                account: '',
                ruleName: '',
                configRule: '',
                monitorIndex: '',
                backupRegion: [],
                modal_loadings:false,
                addloading:false,
                singleBackupRegion:false,
                singleConfigRuleNames:false,
                isDisable:true,
                accountList: [],
                notificationObjectList: [],
                backupRegionList: [],
                configRuleNamesList:[],
                loading: true,
                addWhitelistVisible: false,
                modal_loading: false,
                selection:[],
                column:[
                  {
                    type: 'selection',
                    width: 60,
                    align: 'center'
                  },
                  {
                    key: 'resourceName',
                    title: this.$t('alarms.complianceChecks.ResourceName')
                  },
                  {
                    key: 'resourceId',
                    title: this.$t('alarms.complianceChecks.ResourceID')
                  },
                  {
                    key: 'resourceType',
                    title: this.$t('alarms.complianceChecks.ResourceType')
                  },
                  {
                    key: 'complianceType',
                    title: this.$t('alarms.complianceChecks.ResourceComplianceStatus')
                  }
                ],
                complianceChecksWhitelistData:[],
                newTableWhitelistDataList:[]
            }
        },
        beforeCreate: function () {
            addComplianceChecksWhitelist = this
        },
        mounted () {
          if (this.company == 1) {
            this.getCompanyDropDownBox();
          }
        },
        methods: {
            init:function () {
                this.addWhitelistVisible = true;
            },
            // 获取公司下拉框
            getCompanyDropDownBox: function(){
              this.$api.company.getCompanyDropDownBox("userName",getCookie(global.cookieName))
                .then(res => {
                  this.companyList = res.data;
                });
            },
            // 根据公司或用户名查询Account列表
            getAccountList: function () {
                this.$api.account.getAWSAccountByCompanyId("companyId",this.companyId).then(res => {
                    this.accountList = res.data;
                })
            },
            // 选择地区
            getRegionList: function(){
                this.$api.account.queryAccountRegions("accountId", this.accountId).then(res => {
                    this.regionList = res.data;
                });
            },
            // 合规性查询
            getConfigRuleList: function () {
              this.$api.awsConfigCheckItem.queryConfigRuleCheckItems({})
                .then(res => {
                  this.configRuleNamesList = res.data;
                })
            },
            // 查询需要加入白名单的资源
            getResourceList: function (){
                this.modal_loadings = true;
                this.$api.awsConfigCheckItem.queryConfigRuleCheckItemsDetail({
                  "accountId":this.accountId,
                  "region":this.region,
                  "configRuleName":this.configRule,
                  "complianceType":2 //2代表查询所有
                })
                .then(res => {
                  this.complianceChecksWhitelistData=res.data;
                  this.modal_loadings = false;
                })
            },
            // 全选 单选
            /***********************************************************************************/
          // 当前选择checkbox
          getSelection: function (selection) {
            this.selection = selection;
            // 清空数组
            this.newTableWhitelistDataList = [];
            for (var i = 0; i < this.selection.length; i++) {
              const TableWhitelistCopy = new Object();
              TableWhitelistCopy.resourceId = this.selection[i].resourceId;
              TableWhitelistCopy.resourceName = this.selection[i].resourceName;
              TableWhitelistCopy.resourceType = this.selection[i].resourceType;
              TableWhitelistCopy.complianceType = this.selection[i].complianceType;
              TableWhitelistCopy.configRule = this.configRule;
              TableWhitelistCopy.accountId = this.selection[i].accountId;
              TableWhitelistCopy.region = this.selection[i].region;
              this.newTableWhitelistDataList.push(TableWhitelistCopy);
            }
            // 选了数据 可以点击下一步
            if (this.newTableWhitelistDataList.length == 0) {
              this.isDisable = true;
            } else {
              this.isDisable = false;
            }
          },
            //添加白名单
            addWhitelist:function(){
              this.$api.noncompliantResourcesIgnored.ignoreNoncompliantResources({
                "accountId":this.accountId,
                "region":this.region,
                "noncompliantResourcesIgnoredDTOList":this.newTableWhitelistDataList
              })
              .then(res => {
                this.addWhitelistVisible = false;
                setTimeout(() => {
                  this.$Message.success(this.$t('common.addSuccess'));
                  // 清空表格
                  this.newTableWhitelistDataList = [];
                  this.isDisable = true;
                  tableComplianceChecksWhitelist.methods.showAll();
                }, 1000);
              })
          },
          // 取消
          cancel: function () {
            this.isDisable = true;
            this.addWhitelistVisible = false;
            // 清空表格
            this.newTableWhitelistDataList = [];
          }
        }
    }
</script>
<style scoped>
  .complianceChecksWhitelistSearch
  {
    height: 51px;
  }
</style>



// WEBPACK FOOTER //
// src/components/monitor/compliance_checks/complianceChecks_whitelist/AddComplianceChecksWhitelist.vue